'use client';

import { Users, UserPlus, UserCheck, UserX } from 'lucide-react';
import { StatsCard } from '@/core/presentation/components/StatsCard';
import { userGrowthData, kpiData } from '@/features/admin/presentation/data/mockData';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';

export function DashboardUsuarios() {
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <StatsCard
          title="Total de usuários"
          value={kpiData.totalUsers.toLocaleString('pt-BR')}
          icon={<Users className="h-5 w-5 text-admin-cyan-dark" />}
          trend={12.5}
          gradient
        />
        <StatsCard
          title="Novos (mês)"
          value="1.180"
          icon={<UserPlus className="h-5 w-5 text-admin-cyan-dark" />}
          trend={6.2}
        />
        <StatsCard
          title="Ativos"
          value={kpiData.activeUsers.toLocaleString('pt-BR')}
          icon={<UserCheck className="h-5 w-5 text-admin-cyan-dark" />}
          trend={4.8}
        />
        <StatsCard
          title="Churn"
          value={`${kpiData.churnRate}%`}
          icon={<UserX className="h-5 w-5 text-admin-cyan-dark" />}
          trend={-0.5}
        />
      </div>

      <div className="bg-white rounded-xl border border-admin-border p-5 shadow-sm">
        <h3 className="text-sm font-semibold text-admin-text mb-4">Crescimento de usuários</h3>
        <ResponsiveContainer width="100%" height={280}>
          <LineChart data={userGrowthData}>
            <CartesianGrid strokeDasharray="3 3" stroke="#E2EAF8" />
            <XAxis dataKey="month" tick={{ fontSize: 12, fill: '#718096' }} />
            <YAxis tick={{ fontSize: 12, fill: '#718096' }} />
            <Tooltip />
            <Line type="monotone" dataKey="novos" stroke="#7ECFEF" strokeWidth={2} dot={{ r: 4 }} />
            <Line type="monotone" dataKey="ativos" stroke="#0D1B5E" strokeWidth={2} dot={{ r: 4 }} />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}

